<template>
  <div class="ai-home">
    <section class="ai-hero">
      <h2 class="ai-hero__title">시각화</h2>
      <p class="ai-hero__sub">
        M3D 반도체 소재·공정 데이터 HUB에 축적된 실험·계산 데이터를<br />
        데이터 연관관계와 지식그래프로 탐색해 보세요.
      </p>
    </section>

    <section class="ai-menu">
      <router-link to="/data-visualization/correlation" class="ai-menu__card">
        <div class="ai-menu__icon">
          <svg viewBox="0 0 48 48" aria-hidden="true">
            <rect x="6" y="6" width="10" height="10" rx="2" fill="#003f67" />
            <rect x="19" y="6" width="10" height="10" rx="2" fill="#5a86a8" />
            <rect x="32" y="6" width="10" height="10" rx="2" fill="#c7d8e4" />
            <rect x="6" y="19" width="10" height="10" rx="2" fill="#5a86a8" />
            <rect x="19" y="19" width="10" height="10" rx="2" fill="#0dbde9" />
            <rect x="32" y="19" width="10" height="10" rx="2" fill="#5a86a8" />
            <rect x="6" y="32" width="10" height="10" rx="2" fill="#c7d8e4" />
            <rect x="19" y="32" width="10" height="10" rx="2" fill="#5a86a8" />
            <rect x="32" y="32" width="10" height="10" rx="2" fill="#003f67" />
          </svg>
        </div>
        <div class="ai-menu__body">
          <h3>데이터 연관관계</h3>
          <p>
            n형·p형 반도체, 적층소재, M3D 소자, 계산 데이터로<br />
            공정·특성 간 상관관계를 히트맵으로 탐색합니다.
          </p>
        </div>
        <span class="ai-menu__go">바로가기 →</span>
      </router-link>

      <router-link to="/data-visualization/knowledge-graph" class="ai-menu__card">
        <div class="ai-menu__icon">
          <svg viewBox="0 0 48 48" aria-hidden="true">
            <line x1="24" y1="10" x2="10" y2="30" stroke="#9db8ca" stroke-width="2" />
            <line x1="24" y1="10" x2="38" y2="30" stroke="#9db8ca" stroke-width="2" />
            <line x1="10" y1="30" x2="38" y2="30" stroke="#9db8ca" stroke-width="2" />
            <line x1="24" y1="10" x2="24" y2="40" stroke="#9db8ca" stroke-width="2" />
            <circle cx="24" cy="10" r="6" fill="#003f67" />
            <circle cx="10" cy="30" r="5" fill="#0dbde9" />
            <circle cx="38" cy="30" r="5" fill="#5a86a8" />
            <circle cx="24" cy="40" r="4" fill="#c7d8e4" />
          </svg>
        </div>
        <div class="ai-menu__body">
          <h3>지식그래프</h3>
          <p>
            계열별 공정 항목·속성 구조와 데이터 기반<br />
            상관관계를 그래프로 탐색합니다.
          </p>
        </div>
        <span class="ai-menu__go">바로가기 →</span>
      </router-link>

      <router-link to="/data-visualization/search" class="ai-menu__card">
        <div class="ai-menu__icon">
          <svg viewBox="0 0 48 48" aria-hidden="true">
            <rect x="6" y="8" width="36" height="7" rx="3.5" fill="#c7d8e4" />
            <rect x="6" y="20" width="24" height="7" rx="3.5" fill="#5a86a8" />
            <rect x="6" y="32" width="30" height="7" rx="3.5" fill="#003f67" />
            <circle cx="37" cy="33" r="7" fill="#fff" stroke="#0dbde9" stroke-width="2.5" />
            <line x1="42" y1="38" x2="46" y2="42" stroke="#0dbde9" stroke-width="2.5" stroke-linecap="round" />
          </svg>
        </div>
        <div class="ai-menu__body">
          <h3>데이터 기반 검색</h3>
          <p>
            공정 조건을 필터처럼 체크해 실험 행을 고르고<br />
            선택한 행의 출력 특성을 비교합니다.
          </p>
        </div>
        <span class="ai-menu__go">바로가기 →</span>
      </router-link>
    </section>
  </div>
</template>

<script>
export default {
  name: "DvHome",
};
</script>

<style lang="scss" scoped>
.ai-home {
  max-width: 1100px;
  margin: 0 auto;
  padding: 60px 20px 120px;
}
.ai-hero {
  text-align: center;
  margin-bottom: 48px;
  &__title {
    font-size: 30px;
    font-weight: 700;
    color: #003f67;
    letter-spacing: -0.5px;
  }
  &__sub {
    margin-top: 14px;
    font-size: 15px;
    color: #556;
    line-height: 24px;
  }
}
.ai-menu {
  display: flex;
  gap: 24px;
  justify-content: center;
  flex-wrap: wrap;

  &__card {
    display: flex;
    flex-direction: column;
    width: 340px;
    padding: 30px 28px 26px;
    border: 1px solid #dde6ec;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 4px 20px rgba(9, 76, 177, 0.08);
    text-decoration: none;
    transition: box-shadow 0.15s, transform 0.15s, border-color 0.15s;

    &:hover {
      border-color: #0dbde9;
      box-shadow: 0 8px 28px rgba(9, 76, 177, 0.16);
      transform: translateY(-3px);
    }
  }
  &__icon {
    width: 48px;
    height: 48px;
    margin-bottom: 20px;
    svg {
      width: 100%;
      height: 100%;
    }
  }
  &__body {
    h3 {
      font-size: 21px;
      font-weight: 700;
      color: #111;
      letter-spacing: -0.4px;
    }
    p {
      margin-top: 12px;
      font-size: 14px;
      color: #556;
      line-height: 22px;
    }
  }
  &__go {
    margin-top: 22px;
    font-size: 14px;
    font-weight: 600;
    color: #003f67;
  }
}
</style>
